import React, { useState, useEffect, useCallback } from "react";

const ExperienceCard = () => {

    return (

        <div className="col-md-12 col-xl-12">
            <div className="card shadow-lg p-3 mb-5 bg-white rounded">

                <ul
                id="controlled-tab"
                className="nav nav-tabs nav-justified explist"
                >
                    <li className="nav-item pill-1">
                        <a class="nav-link" data-toggle="tab" href="#tab1">Science & Engineering</a>
                    </li>
                    <li class="nav-item pill-2">
                        <a class="nav-link active" data-toggle="tab" href="#tab2">Data Science & AI</a>
                    </li>
                    <li class="nav-item pill-3">
                        <a class="nav-link" data-toggle="tab" href="#tab3">Software Engineering</a>
                    </li>
                </ul>

                <div class="tab-content mt-3">
                    <div class="tab-pane fade" id="tab1" role="tabpanel">
                        <div className="p-4">
                            <div className="text-center">
                                <h1>Science & Engineering</h1>
                            </div>
                            <div className="exptab my-1">
                                <p>
                                    <hr />
                                </p>
                                <p>
                                    <h3>Professional Experience:</h3>
                                    <br></br>
                                </p>
                                <p>  
                                    <h4>
                                        Regenerative Processing Plant (Jan 2020 - Jun 2020)<br></br>
                                    </h4>
                                    <p className="expsectiontitles">
                                        &nbsp;&nbsp;&nbsp; Lead Laboratory Biochemist 
                                    </p>
                                    <ul>
                                        <li>
                                            Conducted research as the lead lab biochemist, producing FDA approved engineered biologics. Outputs were used in the synthesis of medical and pharmaceutical products sold internationally. Developed and optimized procedures handling collagen 1 and 3 extraction from placentas and umbilical cords.
                                        </li>
                                        <li>
                                            Carried out various biochemical processes, including protein extraction, filtration, and purification. Research was carried out while operating under sterile conditions working with volatile chemical compounds and solutions. 
                                        </li>
                                        <li>
                                            Aided in company-wide production and assembly of Regener-eyes® eye drops. Gained experience contributing to the production and assembly of multiple biologically engineered products.
                                        </li>
                                        <li>
                                            Managed selection and implementation of company lab equipment. Summarized and presented innovative research that contributed to procedural and experimental efficiency.  
                                            <br></br><br></br>
                                        </li>
                                    </ul>
                                    <h4>
                                        Research Laboratory of Dr. Igor Alabugin, Florida State University (Jan 2018 - Jan 2019) <br></br>
                                    </h4>
                                    <p className="expsectiontitles">
                                        &nbsp;&nbsp;&nbsp; Undergraduate Research Assistant 
                                    </p>
                                    <ul>
                                        <li>
                                            Designed and synthesized unique molecules and worked to more efficiently recreate existing molecules. Research was focused on the discovery of new ways to control molecular structure and reactivity.
                                        </li>
                                        <li>
                                            Specialized in synthesizing molecules possessing cyclic nature. Successful experiments focused on bonding common nitrogen groups to stable carbonic rings.
                                        </li>
                                        <li>
                                            Gained experience analyzing and presenting scientific research while developing an understanding of experimental troubleshooting and problem solving. 
                                            <br></br><br></br>
                                        </li>
                                    </ul>
                                    <h4>
                                        Research Laboratory of Dr. Hong Li, Florida State University (Aug 2016 - Dec 2017) <br></br>
                                    </h4>
                                    <p className="expsectiontitles">
                                        &nbsp;&nbsp;&nbsp; Undergraduate Research Assistant
                                    </p>
                                    <ul>
                                        <li>
                                            Conducted research on protein expression and analysis in bacterial and plant cells studying a diverse range of RNA:protein, RNA:RNA, and protein:protein interactions that occur at the level of transcription and translation as well as post-transcriptional modifications.
                                        </li>
                                        <li>
                                            Focused primarily on applications of biochemistry and molecular biophysics to better understand the structural mechanisms of molecular assemblies taking place throughout gene expression and regulation processes.
                                        </li>
                                        <li>
                                            Gained experience working with high-level X-ray crystallography microscopes to effectively probe proteins within their natural cellular environment. Conducted complex 3-dimensional model analysis to explore the atomic details held within the various functional pathways. 
                                            <br></br><br></br>
                                        </li>
                                    </ul>
                                </p>
                                <p>
                                    <hr />
                                </p>
                                <p>
                                    <h3>Laboratory Skills:</h3>
                                    <br></br>
                                </p>
                                <ul className="m-3">
                                    <li>
                                        Chromatography (column, Ion exchange, HPLC, GC, GCMS)
                                    </li>
                                    <li>
                                        Spectroscopy (flame, Absorbance, Raman, IR, FTIR, UV-Vis)
                                    </li>
                                    <li>
                                        Nuclear Magnetic Resonance (NMR) spectrum
                                    </li>
                                    <li>
                                        Electron Microscopy
                                    </li>
                                    <li>
                                        Controlled protein expression and extraction
                                    </li>
                                    <li>
                                        Centrifugation, compound isolation
                                    </li>
                                    <li>
                                        Laboratory filtration (Vacuum, Gravity, Multilayer)
                                    </li>
                                    <li>
                                        Gel Electrophoresis
                                    </li>
                                    <li>
                                        Polymerase Chain Reaction
                                    </li>
                                    <li>
                                        Data processing and visualization
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade show active" id="tab2" role="tabpanel">
                        <div className="p-4">
                            <div className="text-center">
                                <h1>Data Science & Artificial Intelligence</h1>
                            </div>
                            <div className="exptab">
                                <p>
                                    <hr />
                                </p>
                                <div className="d-none d-sm-block col-sm-12">
                                    <p className="text-center fa-3x">
                                        <i class="fab fa-python col-1"></i>

                                        <i class="fab fa-js-square col-1"></i>

                                        <i class="fab fa-react col-1"></i>

                                        <i class="fab fa-unity col-1"></i>

                                        <i class="fab fa-aws col-1"></i>
                                    </p>
                                </div>
                                <p>
                                    <h4>Applications<br></br><br></br></h4>
                                    <ul>
                                        <li>Proficiency in writing and working with machine learning and deep learning models. Worked with designing training environments and models, applying data analysis and visualization for analytical problem solving. </li>
                                        <li>
                                            Experience building machine learning and deep learning algorithms and models from scratch, implementing pre-existing models, and transfer learning utilization. 
                                        </li>
                                        <li>
                                            Proven ability in program development and automation using Python and Javascript to construct projects ranging across:
                                                <ul className="mt-3 mb-3">
                                                    <li>
                                                        Algorithmic and analytical data processing and visualization. Have constructed projects working with manipulatable data as well as pre-existing data sets. 
                                                    </li>
                                                    <li>
                                                        Automated stock forecasting and trading (theoretical) to predict markets and marginalize profit. Experience designing small programs analyzing and forecasting both volatile and stable markets LSTM Time Series Prediction and Analysis. 
                                                    </li>
                                                    <li>
                                                        General task automation working with various concepts including web scraping, IP requests, and general tasks such as news and information scraping, router connection based signaling, as well as file organization and storage. 
                                                    </li>
                                                    <li>
                                                        Data parsing, munging, wrangling, transforming, and analysis for increased machine learning and deep learning model optimization. 
                                                    </li>
                                                    <li>
                                                        External framework interaction implementing trained models in Python and Javascript onto frontend framework web applications.
                                                    </li>
                                                </ul>
                                            <li>
                                                Experience working with data manipulation, machine learning, and deep learning in multiple cloud and computing platforms including Amazon Web Services, Google Cloud, and Jupyter Notebook. 
                                            </li>
                                            <li>
                                                Independent game development experience working with Unity, C#, Procreate, and Photoshop to construct 2D platformers. Developed functioning enemy AI and player controls within interactive environments possessing level-rendered control. 
                                            </li>
                                        </li>
                                    </ul>
                                    <h4>Skills<br></br></h4>
                                    <div class="container text-center">
                                        <div class="row mt-4">
                                            <div class="col-sm">
                                            Python
                                            </div>
                                            <div class="col-sm">
                                            Javascript
                                            </div>
                                            <div class="col-sm">
                                            Tensorflow 2
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-sm">
                                            Unity
                                            </div>
                                            <div class="col-sm">
                                            C#
                                            </div>
                                            <div class="col-sm">
                                            PyTorch
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-sm">
                                            Keras
                                            </div>
                                            <div class="col-sm">
                                            Google Colab
                                            </div>
                                            <div class="col-sm">
                                            AWS
                                            </div>
                                        </div>
                                    </div>
                                    <p>
                                        <br></br><br></br>
                                        Certifications: Neural Networks and Deep Learning, Improving Deep Neural Networks: Hyperparameter tuning, Regularization and Optimization, Structuring Machine Learning Projects, Convolutional Neural Networks, Sequence Models, Python

                                    </p>
                                    <p>
                                        Specializations: Deep Learning
                                    </p>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab3" role="tabpanel">
                        <div className="p-4">
                            <div className="text-center">
                                <h1>Software Engineering</h1>
                            </div>
                            <div className="exptab">
                                <p>
                                    <hr />
                                </p>
                                <div className="d-none d-sm-block col-sm-12">
                                    <p className="text-center fa-3x">
                                        <i class="fab fa-js-square col-1"></i>

                                        <i class="fab fa-react col-1"></i>

                                        <i class="fab fa-css3 col-1"></i>

                                        <i class="fab fa-html5 col-1"></i>

                                        <i class="fab fa-node-js col-1"></i>

                                        <i class="fab fa-bootstrap col-1"></i>
                                    </p>
                                </div>
                                <p>
                                    <h4>Applications<br></br><br></br></h4>
                                    <ul>
                                        <li>
                                            Experience developing web and mobile applications using JavaScript, React.js, React Native, Node.js, CSS, Scss, HTML5, JQuery, Bootstrap, Express, and MongoDB. 
                                        </li>
                                        <li>
                                            Skilled in front-end web development using React, Javascript, CSS, HTML, and Bootstrap to construct complex single page applications and small multi page websites.  
                                        </li>
                                        <li>
                                            Exposure to working with JQuery DOM manipulation and search engine optimization while navigating within Express - Node.js web applications and MongoDB. 
                                        </li>
                                        <li>
                                            Proficient in commonly used features of Git and can effectively work with remote git repositories in fast-paced environments both independently and in groups. 
                                        </li>
                                        <li>
                                            Experience working in Procreate and Photoshop designing Unity Gaming Assets for 2D platformers and applications. Successfully imported and scripted assets within Unity game engine to allow assets to interact within the game engine environment (Universal Render Pipeline), abide by various laws of gaming physics, and display animated movements and actions.  
                                            <br></br><br></br>
                                        </li>
                                    </ul>
                                    <h4>Skills<br></br></h4>
                                    <div class="container text-center">
                                        <div class="row mt-4">
                                            <div class="col-sm">
                                            Javascript
                                            </div>
                                            <div class="col-sm">
                                            React
                                            </div>
                                            <div class="col-sm">
                                            HTML
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-sm">
                                            CSS
                                            </div>
                                            <div class="col-sm">
                                            Scss
                                            </div>
                                            <div class="col-sm">
                                            Node.js
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-sm">
                                            React Native
                                            </div>
                                            <div class="col-sm">
                                            JQuery
                                            </div>
                                            <div class="col-sm">
                                            Bootstrap
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-sm">
                                            Express
                                            </div>
                                            <div class="col-sm">
                                            MongoDB
                                            </div>
                                            <div class="col-sm">
                                            Git
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-sm">
                                            Procreate
                                            </div>
                                            <div class="col-sm">
                                            Photoshop
                                            </div>
                                            <div class="col-sm">
                                            Unity
                                            </div>
                                        </div>
                                    </div>
                                    <p>
                                        <br></br><br></br>
                                        Specializations: Algorithms, Full-Stack Web Development with React, Computer Science and Programming
                                    </p>
                                    <p>
                                        Certifications: Divide and Conquer, Sorting and Searching, and Randomized Algorithms, Graph Search, Shortest Paths, and Data Structures, Greedy Algorithms, Minimum Spanning Trees, and Dynamic Programming, Programming Foundations with JavaScript, HTML and CSS, Mathematics for Computer Science, FrontEnd Web UI Frameworks and Tools: Bootstrap 4, Front-End Web Development with React, Multiplatform Mobile App Development with React Native, Sever-side Development with NodeJS, Express, and MongoDB
                                    </p>
                                    <p>
                                        Additional Achievements: Constructed multiple functioning PCs
                                    </p>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExperienceCard;